<template>
  <section class="py-5 bg-white text-dark">
    <div class="container">
      <h1 class="mb-4 text-primary fw-bold">Legislație achiziții publice</h1>
      <p>Mai jos regăsești cele mai importante acte normative în domeniul achizițiilor publice, explicate și structurate clar.</p>

      <div class="accordion" id="legislatieAccordion">

        <!-- OUG 114/2020 -->
        <div class="accordion-item border-0 border-bottom">
          <h2 class="accordion-header">
            <button class="accordion-button fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#ou114" aria-expanded="true">
              <i class="fas fa-gavel me-2 text-primary"></i>OUG nr. 114/2020 – Simplificare și accelerare achiziții publice
            </button>
          </h2>
          <div id="ou114" class="accordion-collapse collapse show" data-bs-parent="#legislatieAccordion">
            <div class="accordion-body">
              <p>
                Ordonanța de urgență nr. 114 din 09.07.2020 a fost adoptată de Guvernul României pentru a <strong>simplifica și accelera</strong> procedurile de achiziții publice.
              </p>
              <p>
                Totodată, aceasta pune în acord legislația cu decizia Curții Constituționale privind neconstituționalitatea unor articole din OUG nr. 23/2020. Vizau modul de funcționare al instanțelor ce judecau contestațiile în materie de achiziții publice.
              </p>
              <p class="mb-0">
                Scopul principal al ordonanței este creșterea eficienței sistemului și reducerea duratei de atribuire a contractelor publice.
              </p>
            </div>
          </div>
        </div>

        <!-- Instrucțiunea nr. 1/2019 -->
<div class="accordion-item border-0 border-bottom">
  <h2 class="accordion-header">
    <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#instr1" aria-expanded="false">
      <i class="fas fa-balance-scale me-2 text-primary"></i>Instrucțiunea nr. 1/2019 – Ajustarea prețului contractului de achiziție publică/sectorială
    </button>
  </h2>
  <div id="instr1" class="accordion-collapse collapse" data-bs-parent="#legislatieAccordion">
    <div class="accordion-body">
      <p>
        Instrucțiunea nr. 1/2019 emisă de <strong>ANAP</strong> modifică și clarifică prevederile legate de ajustarea prețurilor în contractele de achiziții publice și sectoriale, în contextul OUG nr. 114/2018, Legii 98/2016 și Legii 99/2016.
      </p>

      <h6 class="fw-semibold"><i class="fas fa-edit me-2 text-secondary"></i>Modificări esențiale:</h6>
      <ul>
        <li><i class="fas fa-arrow-right me-2 text-primary"></i>Ajustarea se poate face doar dacă există prevederi clare în documentația de atribuire și în contract</li>
        <li><i class="fas fa-arrow-right me-2 text-primary"></i>Se introduce formula de revizuire aplicabilă la fiecare plată</li>
        <li><i class="fas fa-arrow-right me-2 text-primary"></i>Revizuirea nu se aplică dacă coeficientul de ajustare este subunitar</li>
      </ul>

      <h6 class="fw-semibold mt-3"><i class="fas fa-exclamation-circle me-2 text-secondary"></i>Situații imprevizibile ce justifică actualizarea prețului:</h6>
      <ul>
        <li>📌 Modificări legislative sau administrative (ex: taxe locale)</li>
        <li>📌 Creșterea salariului minim</li>
        <li>📌 Modificarea normativelor tehnice după semnarea contractului</li>
        <li>📌 Prelungirea duratei de atribuire peste valabilitatea ofertei</li>
        <li>📌 Prelungirea execuției din motive neimputabile contractantului</li>
      </ul>

      <p class="mt-3">
        Autoritatea contractantă poate aplica simultan mecanisme de <strong>revizuire</strong> și <strong>actualizare</strong> a prețurilor.
        Aceste clarificări vin în urma sesizărilor din piață și au ca scop aplicarea unitară și transparentă a prevederilor.
      </p>
    </div>
  </div>
</div>
<!-- HG 395/2016 -->
<div class="accordion-item border-0 border-bottom">
  <h2 class="accordion-header">
    <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#hg395" aria-expanded="false">
      <i class="fas fa-file-contract me-2 text-primary"></i>HG nr. 395/2016 – Norme metodologice de aplicare a Legii 98/2016
    </button>
  </h2>
  <div id="hg395" class="accordion-collapse collapse" data-bs-parent="#legislatieAccordion">
    <div class="accordion-body">
      <p>
        HG 395/2016, publicată în Monitorul Oficial nr. 423 din 6 iunie 2016, stabilește Normele metodologice de aplicare a prevederilor Legii 98/2016 privind achizițiile publice :contentReference[oaicite:1]{index=1}.
      </p>
      <ul>
        <li><i class="fas fa-check me-2 text-success"></i>Definește interpretarea principiilor și procedurilor</li>
        <li><i class="fas fa-check me-2 text-success"></i>Reglementează atribuirea contractelor, achizițiile directe, documentația necesară</li>
        <li><i class="fas fa-check me-2 text-success"></i>Include reglementări privind comisia de evaluare, dosarul achiziției (Art. 148)</li>
        <li><i class="fas fa-check me-2 text-success"></i>Reglementează rolul compartimentelor de achiziții din autorități</li>
      </ul>
      <p class="mt-2">
        Normele au fost actualizate periodic pentru a reflecta schimbări legislative. Sunt esențiale pentru o implementare corectă și transparentă a achizițiilor publice.
      </p>
      <p class="mt-3">
        <a href="https://legislatie.just.ro/Public/DetaliiDocument/179009" target="_blank" class="text-decoration-none">
          <i class="fas fa-external-link-alt me-1"></i>Vezi forma oficială pe portalul legislativ
        </a>
      </p>
    </div>
  </div>
</div>
<!-- HG 394/2016 -->
<div class="accordion-item border-0 border-bottom">
  <h2 class="accordion-header">
    <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#hg394" aria-expanded="false">
      <i class="fas fa-file-contract me-2 text-primary"></i>HG nr. 394/2016 – Norme metodologice pentru contracte sectoriale/acord-cadru (Legea 99/2016)
    </button>
  </h2>
  <div id="hg394" class="accordion-collapse collapse" data-bs-parent="#legislatieAccordion">
    <div class="accordion-body">
      <p>
        HG 394/2016, aprobată prin Monitorul Oficial nr. 422 din 6 iunie 2016, stabilește Normele metodologice privind atribuirea contractelor sectoriale și acordurilor-cadru conform Legii 99/2016 :contentReference[oaicite:1]{index=1}.
      </p>
      <ul>
        <li><i class="fas fa-check me-2 text-success"></i>Definește procedurile și principiile de atribuire</li>
        <li><i class="fas fa-check me-2 text-success"></i>Reglementează înregistrarea, reînnoirea și recuperarea în SEAP</li>
        <li><i class="fas fa-check me-2 text-success"></i>Include cerințe privind comisiile de evaluare și documentația aferentă</li>
      </ul>
      <p class="mt-2">
        Aceste norme sunt esențiale pentru implementarea corectă și uniformă a legislației sectoriale.
      </p>
      <p class="mt-3">
        <a href="https://legislatie.just.ro/Public/DetaliiDocument/178987" target="_blank" class="text-decoration-none">
          <i class="fas fa-external-link-alt me-1"></i>Vezi forma oficială pe portalul legislativ
        </a>
      </p>
    </div>
  </div>
</div>
<!-- HG 867/2016 -->
<div class="accordion-item border-0 border-bottom">
  <h2 class="accordion-header">
    <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#hg867" aria-expanded="false">
      <i class="fas fa-file-contract me-2 text-primary"></i>HG nr. 867/2016 – Norme metodologice pentru Legea 100/2016 (concesiuni)
    </button>
  </h2>
  <div id="hg867" class="accordion-collapse collapse" data-bs-parent="#legislatieAccordion">
    <div class="accordion-body">
      <p>
        HG 867/2016, publicată în Monitorul Oficial nr. 985 din 7 decembrie 2016, aprobă normele metodologice privind<br>
        atribuirea concesiunilor de lucrări și servicii conform <strong>Legii 100/2016</strong> :contentReference[oaicite:0]{index=0}.
      </p>
      <ul>
        <li><i class="fas fa-check me-2 text-success"></i>Definește proceduri și principii de atribuire specifice concesiunilor</li>
        <li><i class="fas fa-check me-2 text-success"></i>Include reguli de evaluare, contractare și adaptări la legislație europeană</li>
        <li><i class="fas fa-check me-2 text-success"></i>Stabilește condiții pentru modificarea contractelor fără reluarea procedurii</li>
      </ul>
      <p class="mt-2">
        Normele au fost actualizate pentru a asigura aplicarea corectă a concesiunilor și alinierea cu directivele europene.
      </p>
      <p class="mt-3">
        <a href="https://legislatie.just.ro/Public/DetaliiDocument/184355" target="_blank" class="text-decoration-none">
          <i class="fas fa-external-link-alt me-1"></i>Vezi forma oficială pe portalul legislativ
        </a>
      </p>
    </div>
  </div>
</div>
<!-- Legea 101/2016 -->
<div class="accordion-item border-0 border-bottom">
  <h2 class="accordion-header">
    <button class="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#lege101" aria-expanded="false">
      <i class="fas fa-gavel me-2 text-primary"></i>Legea nr. 101/2016 – Remedii și căile de atac (CNSC)
    </button>
  </h2>
  <div id="lege101" class="accordion-collapse collapse" data-bs-parent="#legislatieAccordion">
    <div class="accordion-body">
      <p>
        Publicată în <strong>Monitorul Oficial nr. 393/23.05.2016</strong>, Legea 101/2016 reglementează căile de atac (administrativ-jurisdicțională și judiciară) pentru contestațiile în achiziții publice, contracte sectoriale și concesiuni, organizând și funcționarea CNSC :contentReference[oaicite:1]{index=1}.
      </p>
      <ul>
        <li><i class="fas fa-check me-2 text-success"></i>Stabilește cadrul legal pentru depunerea și soluționarea contestațiilor</li>
        <li><i class="fas fa-check me-2 text-success"></i>Definirea termenelor: 7 zile (sub praguri UE) și 10 zile (peste praguri UE)</li>
        <li><i class="fas fa-check me-2 text-success"></i>Regăsești procedura de sesizare a CNSC și a instanțelor superioare</li>
        <li><i class="fas fa-check me-2 text-success"></i>Reglementează cauțiunea, efectele suspendării executării și accesul la acte</li>
      </ul>
      <p class="mt-2">
        Scopul legii este de a asigura remedii rapide și eficiente, aliniate cu directivele europene.
      </p>
      <p class="mt-3">
        <a href="https://legislatie.just.ro/Public/DetaliiDocument/178680" target="_blank" class="text-decoration-none">
          <i class="fas fa-external-link-alt me-1"></i>Consultă textul integral pe portalul legislativ
        </a>
      </p>
    </div>
  </div>
</div>
      </div>
    <div class="mt-5 pt-4 border-top">
  <h5 class="fw-bold mb-3">
    <i class="fas fa-folder-open me-2 text-primary"></i>Resurse utile & texte oficiale
  </h5>
  <ul class="list-unstyled">
    <li class="mb-2">
      <i class="fas fa-file-pdf me-2 text-secondary"></i>
      <a href="https://legislatie.just.ro/Public/DetaliiDocument/179009" target="_blank" class="text-decoration-none">
        HG 395/2016 – Norme metodologice de aplicare a Legii 98/2016 (Monitor OF. nr. 423/06.06.2016)
      </a>
    </li>
    <li class="mb-2">
      <i class="fas fa-file-pdf me-2 text-secondary"></i>
      <a href="https://anap.gov.ro/web/wp-content/uploads/2016/06/HG-395-2016-varianta-acutalizata-din-data-de-18-iunie-2018.pdf" target="_blank" class="text-decoration-none">
        HG 395/2016 – versiune actualizată (iunie 2018)
      </a>
    </li>
  <li class="mb-2">
  <i class="fas fa-file-pdf me-2 text-secondary"></i>
  <a href="https://legislatie.just.ro/Public/DetaliiDocument/178987" target="_blank" class="text-decoration-none">
    HG 394/2016 – Norme metodologice Legea 99/2016 (Monitor OF. nr. 422/06.06.2016)
  </a>
</li>
<li class="mb-2">
  <i class="fas fa-file-pdf me-2 text-secondary"></i>
  <a href="https://legislatie.just.ro/Public/DetaliiDocument/184355" target="_blank" class="text-decoration-none">
    HG 867/2016 – Norme metodologice Legea 100/2016 (Monitor OF. nr. 985/07.12.2016)
  </a>
</li>
<li class="mb-2">
  <i class="fas fa-file-pdf me-2 text-secondary"></i>
  <a href="https://legislatie.just.ro/Public/DetaliiDocument/178680" target="_blank" class="text-decoration-none">
    Legea 101/2016 – Remedii și căile de atac, CNSC (Monitor OF. nr. 393/23.05.2016)
  </a>
</li>

  </ul>
</div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'LegislatiePage'
}
</script>
